import { createAction } from "@reduxjs/toolkit";

export const setTournamentError = createAction<string | null>("tournament/setError");
